import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import CreditorList01Actions, { CreditorList01Types } from '../Stores/CreditorList01/Actions';

const getAppStore = state => state.app;

export function* creditorList01FetchCreditorList01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(CreditorList01Actions.creditorList01FetchCreditorList01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `creditor/indexProcess/CREDITOR_LIST_01`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        CreditorList01Actions.creditorList01FetchCreditorList01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CreditorList01Actions.creditorList01FetchCreditorList01Loading(false));
  }
}

export function* creditorList01GoToResource({ resId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/creditorDetail/update/${resId}/GENERAL`));
}

export function* creditorList01NewResource() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/creditorDetail/create/0/GENERAL`));
}

export const saga = [
  takeLatest(CreditorList01Types.CREDITOR_LIST01_GO_TO_RESOURCE, creditorList01GoToResource),
  takeLatest(
    CreditorList01Types.CREDITOR_LIST01_FETCH_CREDITOR_LIST01,
    creditorList01FetchCreditorList01
  ),
  takeLatest(CreditorList01Types.CREDITOR_LIST01_NEW_RESOURCE, creditorList01NewResource)
];
